import { useEffect, useRef } from "react"

/** How often lists are fetched again, so changes made elsewhere show up. */
export const REFRESH_EVERY_MS = 20_000

/**
 * Calls `callback` every `intervalMs` while `enabled`. Skips a beat while the
 * tab is hidden - nobody is looking - and catches up as soon as it is shown.
 * The latest callback is always the one called, so it need not be memoised.
 */
export function usePolling(callback, intervalMs = REFRESH_EVERY_MS, enabled = true) {
	const saved = useRef(callback)
	saved.current = callback

	useEffect(() => {
		if (!enabled) return undefined
		const tick = () => {
			if (!document.hidden) saved.current()
		}
		const timer = setInterval(tick, intervalMs)
		document.addEventListener("visibilitychange", tick)
		return () => {
			clearInterval(timer)
			document.removeEventListener("visibilitychange", tick)
		}
	}, [intervalMs, enabled])
}
